<template>
    <div class="row _ongoing__block" v-if="promoIsLoading">
        <div class="col-md-12">
          <half-circle-spinner
            :animation-duration="750"
            :size="100"
            color="#1D3354"
            class="mx-auto"
          />
        </div>
    </div>
    <div class="d-flex flex-row __sectionlist" v-else>
        <div class="d-flex flex-row __promoinfo" v-for="item in promo" :key="item.id">
            <div class="d-flex flex-column __sectionleft __background_navy align-items-start justify-content-center">
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <div>
                        <img class="__imgScope" src="@/assets/image/instantprice/AIR CARGO BOX.svg" alt="" v-if="item.scope === 'AIR CARGO'">
                        <img class="__imgScope" src="@/assets/image/instantprice/AIR CARGO BOX.svg" alt="" v-else-if="item.scope === 'Air Cargo'">
                        <img class="__imgScope" src="@/assets/image/instantprice/box air courier.svg" alt="" v-else-if="item.scope === 'AIR COURIER'">
                        <img class="__imgScope" src="@/assets/image/instantprice/box air courier.svg" alt="" v-else-if="item.scope === 'Air Courier'">
                        <img class="__imgScope" src="@/assets/image/instantprice/box LCL@3x.png" alt="" v-else-if="item.scope === 'LCL'">
                        <img class="__imgScope" src="@/assets/image/instantprice/container-white.svg" alt="" v-else>
                    </div>
                    <div class="__fromTo"><p class="__aircargo"> {{getScope(item.scope)}} </p>{{item.origin}} to {{item.destination}} </div>
                </div>
                <p class="__port"><b> {{getOptionTp(item.type)}} </b></p>
                <p class="__period">Valid Until:   {{getDate(item.valid_date)}}</p>
            </div>
            <div class="d-flex flex-column __sectionright align-items-center justify-content-center">
                <p class="__promotitle">Promo:</p>
                <p class="__discPrice"> <b> {{getNewPrice(item.currency,item.new_price,getOptionUom(item.oum),getOptionTp(item.type))}} </b></p>
                <!-- <s class="__oriPrice" v-if="item.new_price !== 'FREE'"> {{getOriginPrice(item.currency,item.original_price,getOptionUom(item.oum))}} </s>
                <s class="__oriPrice" v-else></s> -->
                <!-- <button class="__btnGIN __background_navy" @click="promobookingform()">
                    <p class="__GIN">Get it Now!</p>
                </button> -->
                <u class="__seeDetails __pointer" @click.prevent="seedetails(item.id)">See Details</u>
            </div>
            <div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import moment from 'moment'

export default {
  name: 'PromoList',
  components: {
    HalfCircleSpinner
  },
  methods: {
    seedetails: function (promoId) {
      const details = this.promo.filter(item => (item.id === promoId))
      const id = promoId
      this.$store.dispatch('promo/POST_DATA_TEMP', details[0])
      this.$store.dispatch('promo/FETCH_PROMO_DETAILS', id)
      this.$eventHub.$emit('dialog-details-promo')
    },
    promobookingform: function () {
      this.$router.push({ path: 'promo-booking-form' })
    },
    fetchAllPromo () {
      this.$store.dispatch('promo/FETCH_PROMO')
    },
    getDate (date) {
      return moment(date).format('DD MMMM YYYY')
    },
    getDay (date) {
      return moment(date).format('DD')
    },
    getMonth (date) {
      return moment(date).format('MMMM')
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'PTP' : optionTp = 'Port to Port'
          break
        case 'DTP' : optionTp = 'Door to Port'
          break
        case 'DTD' : optionTp = 'Door to Door'
          break
        case 'PTD' : optionTp = 'Port to Door'
          break
        case 'PTP\r\n' : optionTp = 'Port to Port'
          break
        case 'DTP\r\n' : optionTp = 'Door to Port'
          break
        case 'DTD\r\n' : optionTp = 'Door to Door'
          break
        case 'PTD\r\n' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
      }
      return optionTp
    },
    getOptionUom (type) {
      let optionUom = ''
      switch (type) {
        case 'KG' : optionUom = '/ KG'
          break
        case 'Kg' : optionUom = '/ KG'
          break
        case 'CBM' : optionUom = '/ CBM'
          break
        case 'Container' : optionUom = '/ Container'
          break
        default : optionUom = ''
      }
      return optionUom
    },
    getOriginPrice (currency, originPrice, uom) {
      if (currency === null || currency === '') {
        currency = ''
      }
      if (originPrice === 0) {
        return ''
      } else {
        const number = originPrice.split(',').join('')
        const converted = parseFloat(number)
        const decimal = converted + (converted * 0.05)
        const newOriginPrice = decimal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        const newCurrency = currency
        let optionOriPrice = newCurrency + ' ' + newOriginPrice + ' ' + uom
        return optionOriPrice
      }
    },
    getNewPrice (currency, newprice, uom, type) {
      if (currency === null || currency === '') {
        currency = ''
      }
      const newCurrency = currency
      let optionNewPrice = newCurrency + ' ' + newprice + ' ' + uom
      if (newprice !== 'FREE') {
        return optionNewPrice
      } else { return newprice + ' ' + type }
    },
    getScope (scope) {
      if (scope === 'FCL' || scope === 'ft20' || scope === 'ft40' || scope === 'ft40hc') {
        return 'Ocean ' + scope
      } else if (scope === 'LCL') {
        return 'Ocean ' + scope
      } else { return scope }
    }
  },
  computed: {
    ...mapGetters({
      promo: 'promo/promo',
      promoError: 'promo/error',
      promoIsLoading: 'promo/isLoading'
    })
  },
  mounted () {
    this.fetchAllPromo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promo/PromoList.vue